import React, { useContext, useMemo } from 'react';
import {
	Wrapper,
	Container,
	TableContainer,
	AnalysisDescription,
} from './DetailedAnalysis.styles';
import { defaultGridHeight } from './utils';
import { CategoryInsightsSettingsContext } from 'contexts/CategoryInsightsSettingsContext';
import { useFragmentedCategoriesContext } from 'contexts/CategoryInsightsKpi/FragmentedCategoriesProvider';
import AgGridTable from 'components/AGGridTable/AgGridTable';

const FragmentedCategoriesExplore = () => {
	const { gridData } = useFragmentedCategoriesContext();
	const { fragmentation, vendorCountMax } = useContext(
		CategoryInsightsSettingsContext
	);

	const gridStyle = useMemo(() => defaultGridHeight, []);

	return (
		<Wrapper>
			<Container>
				<AnalysisDescription>
					{`List of categories where top ${vendorCountMax} vendors cover less than ${fragmentation}% of category spend.`}
				</AnalysisDescription>
				<TableContainer>
					<AgGridTable gridOptions={gridData} gridStyle={gridStyle} />
				</TableContainer>
			</Container>
		</Wrapper>
	);
};

export default FragmentedCategoriesExplore;
